<template>
  <div id="app">
    <div v-if="isLoading" class="loader-bg">
      <div class="loader-container">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <router-view />
    <div class="side-bar-backdrop">
      <div v-if="authUser" id="side_bar_app" class="l-sidebar side-bar">
        <!-- <div class="close" @click="hideL">x</div> -->
        <div class="prof-box p-4" @click="hideL">
          <div class="d-flex align-middle align-items-center" @click="showProfile">
            <div>
              <a-avatar
                :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id) }"
                :size="60"
                :src="authUser.user ? authUser.user.url : ``"
                class="text-capitalize"
                alt="avatar"
              >
                {{ getAuthUserInitials() }}
              </a-avatar>
            </div>
            <div class="d-flex flex-column justify-content-center ml-3">
              <p class="profile-name text-wrap text-capitalize mb-1 ml-0 fw700 font18 font-black">
                {{
                  authUser.user.role === "doctor"
                    ? "Dr. " + (authUser.user.first_name ? authUser.user.first_name + " " + authUser.user.last_name : authUser.user.display_name)
                    : authUser.user.first_name
                    ? authUser.user.first_name + " " + authUser.user.last_name
                    : authUser.user.display_name
                }}
              </p>
              <div class="" v-if="authUser.user.role === 'business_administrator'">
                <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                  <font-awesome-icon :icon="['far', 'store']" class="mr-1" />
                  Business
                </span>
              </div>
              <div class="" v-if="authUser.user.role === 'hospital_administrator'">
                <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                  <font-awesome-icon :icon="['far', 'hospital-alt']" class="mr-1" />
                  Hospital
                </span>
              </div>
              <div class="" v-if="authUser.user.role === 'clinic_administrator'">
                <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                  <font-awesome-icon :icon="['far', 'hospital']" class="mr-1" />
                  Clinic
                </span>
              </div>
              <div class="p-0" v-if="authUser.user.role === 'doctor' || authUser.user.role === 'physician'">
                <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                  <font-awesome-icon :icon="['far', 'user-md']" class="mr-1" />
                  Physician
                </span>
              </div>
              <div class="p-0" v-if="authUser.user.role === 'hcp' || authUser.user.role === 'ohcp'">
                <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                  <font-awesome-icon :icon="['far', 'user-nurse']" class="mr-1" />
                  Advanced Practice Provider
                </span>
              </div>
              <div class="post-physician py-1 px-2 m-0 font12 orange-bg orange-text" v-if="authUser.user.role === 'nfp' || authUser.user.role === 'nfp_administrator'">
                <font-awesome-icon :icon="['far', 'hand-holding-heart']" class="mr-1" />
                Non For Profit
              </div>
              <div v-if="authUser.user.role === 'advocate'" class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
                <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
                Advocate
              </div>
            </div>
          </div>
          <div class="current-circle mt-4 gray800 fw700 font16" v-if="currentCircle">
            My Circles
            <div class="d-flex justify-content-between align-items-center mt-4">
              <div class="rounded-circle mr-1 hw24" :style="{ background: getPrimaryColor() }"></div>
              <p class="font-weight-normal text-capitalize mb-0 flex-grow-1 mr-auto" :style="{ 'white-space': 'initial', 'max-width': '200px' }">
                {{ currentCircle ? currentCircle.condition_type : "" }}
              </p>
              <div @click="goToSelectRolePage" class="switch-roles gray500 font10" :style="{ width: '80px', 'text-align': 'right' }">SWITCH ROLE</div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3" v-for="circles in recentlyJoinedCircles" :key="circles.id">
              <div class="rounded-circle mr-1 hw24" :style="{ background: circles.color_code }"></div>
              <p class="font-weight-normal text-capitalize mb-0 flex-grow-1 mr-auto" :style="{ 'white-space': 'initial', 'max-width': '200px' }">
                {{ circles.condition_type }}
              </p>
              <div class="font10" :style="{ color: getPrimaryColor(), width: '80px', 'text-align': 'right' }" @click="goToThisCircle(circles)">ENTER</div>
            </div>
            <div class="viewCircleBG mt-4" :style="{ color: getPrimaryColor() }" @click="goToAllCirclesPage">
              View all my Circles
              <font-awesome-icon size="1x" :icon="['far', 'arrow-right']" class="p-2" :style="{ color: getPrimaryColor(), 'font-size': '20px' }" />
            </div>
          </div>
        </div>
        <hr />
        <ul>
          <li @click="hideL">
            <router-link :to="{ name: 'ActivityHome' }">
              <font-awesome-icon size="2x" class="nav-tab-icons mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('activity') ? 'fas' : 'fal'}`, 'window-maximize']" />
              Activity
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'MyCircleStats' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('mycirclestats') ? 'fas' : 'fal'}`, 'draw-circle']" />
              MyCircle Stats
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'MeetOthers' }">
              <font-awesome-icon size="2x" style="transform: scale(0.7); width: 30px" class="nav-tab-icons mr-2" :icon="[`${$route.path.includes('meetothers') ? 'fas' : 'fal'}`, 'user-plus']" />
              Meet Others
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'MedicalDirectory' }" style="line-height: 24px">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('medicaldirectories') ? 'fas' : 'fal'}`, 'briefcase-medical']" />
              <div style="line-height: normal">
                Medical Directory
                <p class="font10 mb-0">(Physicians, Hospitals, Clinics, and more)</p>
              </div>
            </router-link>
          </li>
          <!-- <li @click="hideL">
            <router-link :to="{ name: 'ProviderDirectory' }">
              <font-awesome-icon
                size="2x"
                style="transform: scale(0.7); width: 30px"
                class="nav-tab-icons mr-2"
                :icon="['fal', 'user-md']"
              />
              Physician Directory
            </router-link>
          </li> -->
          <!-- <li @click="hideL">
            <router-link :to="{ name: 'HospitalDirectory' }">
              <font-awesome-icon
                size="2x"
                style="transform: scale(0.7); width: 30px"
                class="nav-tab-icons mr-2"
                :icon="['fal', 'hospital-alt']"
              />
              Hospital Directory
            </router-link>
          </li> -->
          <!-- <li @click="hideL">
            <router-link :to="{ name: 'ClinicDirectory' }">
              <font-awesome-icon
                size="2x"
                style="transform: scale(0.7); width: 30px"
                class="nav-tab-icons mr-2"
                :icon="['fal', 'hospital']"
              />
              Clinic Directory
            </router-link>
          </li> -->
          <!-- <li @click="hideL">
            <router-link :to="{ name: 'NFPDirectory' }">
              <font-awesome-icon
                size="2x"
                style="transform: scale(0.7); width: 30px"
                class="nav-tab-icons mr-2"
                :icon="['fal', 'hand-holding-heart']"
              />
              Non For Profit Directory
            </router-link>
          </li> -->
          <!-- <li @click="hideL">
            <router-link :to="{ name: 'OtherHealthProfesionalsList' }">
              <font-awesome-icon
                size="2x"
                style="transform: scale(0.7); width: 30px"
                class="nav-tab-icons mr-2"
                :icon="['fal', 'hospital-symbol']"
              />
              Advanced Medical Professionals
            </router-link>
          </li> -->
          <li @click="hideL">
            <router-link :to="{ name: 'MyDoveDirectory' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('mydovedirectory') ? 'fas' : 'fal'}`, 'book-open']" />
              My Dove Directory
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'DoveMedRecommended' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="['fal', 'badge-check']" />
              DoveMed Recommended
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'Recommended' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('recommendations') ? 'fas' : 'fal'}`, 'thumbs-up']" />
              Recommendations
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'Reviews' }">
              <i :class="`${$route.path.includes('reviews') ? 'fa fa-star fa-2x mr-2' : 'fa fa-star-o fa-2x mr-2'}`" aria-hidden="true" style="transform: scale(0.7); width: 30px"></i>
              Reviews
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'meetAdvocates', query: { type: 'others' } }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('meetAdvocates') ? 'fas' : 'fal'}`, 'bullhorn']" />
              Meet Advocates
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'ResourceList' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('resources') ? 'fas' : 'fal'}`, 'book-open']" />
              Resources
            </router-link>
          </li>
          <a :href="`${SSO_BASE_URL}/ask-a-doctor/search?ordering=-recommended&tag=${currentCircleTag()}`" target="_blank" class="ml-1 mb-1 mt-1">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 10.9375C9.53125 10.9375 9.21875 11.2891 9.21875 11.7188C9.21875 12.1484 9.53125 12.5 10 12.5C10.4297 12.5 10.7812 12.1875 10.7812 11.7188C10.7812 11.2891 10.4297 10.9375 10 10.9375ZM17.5 0H2.5C1.09375 0 0 1.13281 0 2.5V13.7109C0 15.1562 1.09375 16.25 2.5 16.25H6.25V19.4922C6.25 19.8828 6.67969 20.0781 6.99219 19.8438L11.875 16.25H17.5C18.8672 16.25 20 15.1172 20 13.75V2.5C20 1.13281 18.8672 0 17.5 0ZM18.75 13.75C18.75 14.4531 18.1641 15 17.5 15H11.8359C11.5625 15 11.3281 15.1172 11.0938 15.2734L7.5 17.9688V15.625C7.5 15.3125 7.1875 15 6.875 15H2.5C1.79688 15 1.25 14.4531 1.25 13.75V2.5C1.25 1.83594 1.79688 1.25 2.5 1.25H17.5C18.1641 1.25 18.75 1.83594 18.75 2.5V13.75ZM10.8594 3.75H8.94531C7.8125 3.75 6.875 4.72656 6.875 5.85938C6.875 6.21094 7.14844 6.48438 7.5 6.48438C7.8125 6.48438 8.125 6.21094 8.125 5.85938C8.125 5.39062 8.47656 5 8.94531 5H10.8594C11.4062 5 11.875 5.46875 11.875 6.01562C11.875 6.40625 11.6406 6.75781 11.2891 6.95312L9.6875 7.77344C9.49219 7.89062 9.375 8.08594 9.375 8.32031V9.375C9.375 9.72656 9.64844 10 10 10C10.3125 10 10.625 9.72656 10.625 9.375V8.71094L11.875 8.04688C12.6172 7.65625 13.125 6.875 13.125 6.01562C13.125 4.76562 12.1094 3.75 10.8594 3.75Z"
                fill="#0F1734"
              />
            </svg>
            <span class="ml-3" style="font-size: 14px;">Ask A Doctor</span>
          </a>
          <li @click="hideL">
            <router-link :to="{ name: 'QA' }">
              <div
                :style="{
                  marginRight: '17px',
                  marginLeft: '5px',
                  stroke: `${$route.path.includes('qa') ? getPrimaryColor() : ''}`,
                }"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 10.9375C9.53125 10.9375 9.21875 11.2891 9.21875 11.7188C9.21875 12.1484 9.53125 12.5 10 12.5C10.4297 12.5 10.7812 12.1875 10.7812 11.7188C10.7812 11.2891 10.4297 10.9375 10 10.9375ZM17.5 0H2.5C1.09375 0 0 1.13281 0 2.5V13.7109C0 15.1562 1.09375 16.25 2.5 16.25H6.25V19.4922C6.25 19.8828 6.67969 20.0781 6.99219 19.8438L11.875 16.25H17.5C18.8672 16.25 20 15.1172 20 13.75V2.5C20 1.13281 18.8672 0 17.5 0ZM18.75 13.75C18.75 14.4531 18.1641 15 17.5 15H11.8359C11.5625 15 11.3281 15.1172 11.0938 15.2734L7.5 17.9688V15.625C7.5 15.3125 7.1875 15 6.875 15H2.5C1.79688 15 1.25 14.4531 1.25 13.75V2.5C1.25 1.83594 1.79688 1.25 2.5 1.25H17.5C18.1641 1.25 18.75 1.83594 18.75 2.5V13.75ZM10.8594 3.75H8.94531C7.8125 3.75 6.875 4.72656 6.875 5.85938C6.875 6.21094 7.14844 6.48438 7.5 6.48438C7.8125 6.48438 8.125 6.21094 8.125 5.85938C8.125 5.39062 8.47656 5 8.94531 5H10.8594C11.4062 5 11.875 5.46875 11.875 6.01562C11.875 6.40625 11.6406 6.75781 11.2891 6.95312L9.6875 7.77344C9.49219 7.89062 9.375 8.08594 9.375 8.32031V9.375C9.375 9.72656 9.64844 10 10 10C10.3125 10 10.625 9.72656 10.625 9.375V8.71094L11.875 8.04688C12.6172 7.65625 13.125 6.875 13.125 6.01562C13.125 4.76562 12.1094 3.75 10.8594 3.75Z"
                    fill="#0F1734"
                  />
                </svg>
              </div>
              Q&A
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'Treatments', query: { type: 'all' } }">
              <font-awesome-icon size="2x" style="transform: scale(0.7); width: 30px" class="nav-tab-icons mr-2" :icon="[`${$route.path.includes('treatments') ? 'fas' : 'fal'}`, 'pills']" />
              Treatments A-Z
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'AboutCircle' }">
              <font-awesome-icon size="2x" class="mr-2" style="transform: scale(0.7); width: 30px" :icon="[`${$route.path.includes('aboutcircle') ? 'fas' : 'fal'}`, 'question-circle']" />
              About the Circle
            </router-link>
          </li>
          <li @click="hideL">
            <router-link :to="{ name: 'CirclesAll' }">
              <font-awesome-icon size="2x" style="transform: scale(0.7); width: 30px" class="nav-tab-icons mr-2" :icon="['fal', 'exchange-alt']" />
              Other Circles
            </router-link>
          </li>
        </ul>
        <hr />
        <button @click="handleLogout" :style="{ background: getSecondaryColor() }" class="primary-button font-white font14 log-out-btn br6 p1224">Log Out</button>
      </div>
      <div class="backdrop" @click="hideL"></div>
    </div>
    <div class="right-side-backdrop" @click="hideR">
      <div class="right-backdrop"></div>
      <div v-if="authUser" class="r-sidebar">
        <div class="close" @click="hideR">x</div>
        <ul>
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <!-- <a-avatar
                :size="60"
                icon="user"
                class="header-profile-image"
                :src="authUser.user.url"
                alt
              /> -->
              <a-avatar
                :style="{
                  color: '#ffffff',
                  'background-color': authUser.user.url ? `` : getAvatarColor(authUser.user.id),
                }"
                :size="40"
                class="header-profile-image text-capitalize"
                :src="authUser.user ? authUser.user.url : ``"
                alt="avatar"
              >
                {{ authUser.user.firstName ? authUser.user.firstName[0] : authUser.user.display_name ? authUser.user.display_name[0] : "D" }}
              </a-avatar>

              <div class="text-capitalize">
                {{ authUser.user.display_name }}
              </div>
            </div>
            <div class="switch-roles" @click="goToSelectRolePage" :style="{ color: getPrimaryColor() }">Switch roles</div>
            <!-- <div v-if="isMultirole" class="switch-roles" @click="goToSelectRolePage" :style="{ color: getPrimaryColor() }">Switch roles</div> -->
          </div>
          <hr />
          <div class="current-circle">
            Current Circle
            <div class="d-flex justify-content-between mt-4">
              <p class="font-weight-normal text-capitalize" v-if="currentCircle">
                {{ currentCircle ? currentCircle.condition_type : "" }}
              </p>
              <div class="switch-roles" :style="{ color: getPrimaryColor() }" @click="goToAllCirclesPage">Switch Circle</div>
            </div>
          </div>
          <hr />
          <li>
            <a rel="noopener noreferrer" @click="showProfile" href="#">MY PROFILE</a>
          </li>
          <!-- <li @click="hideR">
          <router-link :to="{ name: 'ActivityHome' }"
            >YOUR ACTIVITY</router-link
          >
        </li> -->
          <li @click="hideR">
            <router-link :to="{ name: 'AccountSettings' }"> ACCOUNT SETTINGS </router-link>
          </li>
          <li @click="hideR">
            <router-link :to="{ name: 'NotificationSettings' }"> NOTIFICATION SETTINGS </router-link>
          </li>
          <hr />
          <li>
            <button @click="logout" :style="{ background: getPrimaryColor() }" class="dovemed-button primary-button font-white ml-4">LOGOUT</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from "./store"
import "../src/assets/css/antd-dovemed.min.css"
import "./assets/css/custom.scss"
import "bootstrap/dist/css/bootstrap.min.css"
import authService from "./components/login/utils/auth"
import { RepositoryFactory } from "./repositories/RepositoryFactory"
import Repository from "./repositories/Repository"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faQuestionCircle, faStar, faDrawCircle, faPills, faBullhorn, faUserPlus, faUserMd, faHospitalAlt, faHospital, faHospitalSymbol } from "@fortawesome/pro-solid-svg-icons"
import { faThumbsUp, faBookOpen, faBadgeCheck } from "@fortawesome/pro-light-svg-icons"
import axios from "axios"

library.add(faQuestionCircle, faThumbsUp, faPills, faStar, faDrawCircle, faBullhorn, faUserPlus, faUserMd, faHospitalAlt, faHospital, faHospitalSymbol, faBookOpen, faBadgeCheck)
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "app",
  store,

  data() {
    return {
      isMultirole: false,
      recentlyJoinedCircles: [],
    }
  },

  mounted() {
    console.warn("App.vue mounted")
    if (this.$el) {
      this.updateColor()
    }
  },

  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },

  created() {
    console.warn("App.vue created")
    this.rootLoginCheck()
    this.$notification.config({ duration: 5 })
    // this.handleProfileMultiRole()
  },

  updated() {
    // console.log("App updated");
    if (!this.$route.path.includes("userProfile/welcome") || !this.$route.path.includes("activity")) {
      setTimeout(() => {
        document.getElementsByTagName("body")[0].setAttribute("style", "height: 100%")
      }, 100)
    }
    this.updateColor()
  },

  watch: {
    "$route.path": {
      handler() {
        this.hideL()
      },
    },
    currentCircle: {
      async handler() {
        if (this.authUser && this.authUser.user && !this.authUser.user.hasOwnProperty("verified_account")) {
          const res = await UserRepository.getMyRecentlyJoinedCircles(this.currentCircle.id)
          this.recentlyJoinedCircles = res.data.data
        }
      },
      deep: true,
    },
  },

  methods: {
    currentCircleTag() {
      if (this.currentCircle) {
        if(this.currentCircle.circle_hashtag){
          return this.currentCircle.circle_hashtag.toLowerCase();
        }
        return this.currentCircle.condition_type
          .toLowerCase()
          .replace("circle", "")
          .replace("my", "")
          .trim()
          .replace(/-/g, "")
          .replace(/ /g, "")
          .replace(/’/g, "")
          .replace(/'/g, "")
          .substring(0, 33)
      }
      return ""
    },
    handleLogout() {
      this.hideL()
      this.logoutProcess = true
      console.log("App -> handleLogout")
      setTimeout(() => {
        this.logout()
        this.$router.push({ path: "/circles" })
      }, 500)
    },
    goToThisCircle(newCircle) {
      this.$router.push(`/${newCircle.key_name}/select-profile`)
      this.$store.dispatch("Circle/diseaseTypes", { type: newCircle.id })
      this.$store.commit("Circle/setCurrentCircle", { data: newCircle })
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole
            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.newCircle_id === this.currentCircle.id)[0].role
            const payload = { role: selectedRole, circle_id: this.currentCircle.id }

            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, newCircle.id).then(res => {
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          } else {
            this.$router.replace(`/${this.currentCircle.key_name}/select-profile`)
          }
        })
        .catch(err => {})
    },
    rootLoginCheck() {
      console.log("rootLoginCheck()")
      // if (!localStorage.getItem("token")) {
      //   this.logout()
      //   if(!$route.path.includes('contact-us')){
      //     this.$router.push({ path: "/circles" })
      //   }
      // } else {
      authService.methods
        .getUser()
        .then(res => {
          const circleAuth = { dtoken: res.data.token, email: res.data.email }
          localStorage.setItem("user-full-info", JSON.stringify(res.data))
          localStorage.setItem("physician", JSON.stringify(res.data.physician.is_physician))
          localStorage.setItem("hospital", JSON.stringify(res.data.hospital.is_hospital))
          localStorage.setItem("clinic", JSON.stringify(res.data.clinic.is_clinic))
          localStorage.setItem("nfp", JSON.stringify(res.data.nfp.is_nfp))
          localStorage.setItem("ohcp", JSON.stringify(res.data.ohcp.is_ohcp))
          console.log("res.data:", res.data)
          if (!this.authUser) {
            if (res.data.hasOwnProperty("verified_account") && res.data.verified_account === false) {
              const userData = { user: { ...res.data, dtoken: res.data.token } }
              this.$store.commit("User/setUser", { data: userData }, { root: true })
              // if (!res.data.verified_account) {
              // } else if (res.data.verified_account === false) {
              //   this.$store.commit("App/setMail", { email: res.data.email, isVisible: true })
              // console.log("res.data.verified_account", res.data.verified_account)
            } else {
              const userData = { user: { ...res.data, dtoken: res.data.token } }
              this.$store.commit("User/setUser", { data: userData }, { root: true })
              this.setAppLoaderStatus(true)
              this.$store
                .dispatch("Auth/ssoLogin", { circleAuth })
                .then(res => {
                  console.log("Place One") // WHILE COMING FROM CORE DOVEMED
                  const user = this.authUser
                  Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
                  this.setAppLoaderStatus(false)
                })
                .catch(err => {
                  this.setAppLoaderStatus(false)
                })
            }
          }
          if (this.authUser) {
            if (res.data.hasOwnProperty("verified_account") && res.data.verified_account === true) {
              console.log("Place Three")
              if (this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
                const userData = { user: { ...res.data, dtoken: res.data.token } }
                this.$store.commit("User/setUser", { data: userData }, { root: true })
                this.setAppLoaderStatus(true)
                this.$store
                  .dispatch("Auth/ssoLogin", { circleAuth })
                  .then(res => {
                    Repository.defaults.headers.common["Authorization"] = `Bearer ${this.authUser.user.token}`
                    this.setAppLoaderStatus(false)
                  })
                  .catch(err => {
                    this.setAppLoaderStatus(false)
                  })
              }
            }
          }
          // if (res.data.verified_account && this.authUser && this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
          //   const userData = {
          //     user: { email: res.data.email, ...this.authUser.user, verified_account: true },
          //   }
          //   this.$store.commit("User/setUser", { data: userData }, { root: true })
          //   this.setAppLoaderStatus(true)
          //   this.$store
          //     .dispatch("Auth/ssoLogin", { circleAuth })
          //     .then(res => {
          //       console.log("Place Two")
          //       const user = this.$store.state.User.user
          //       Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
          //       this.setAppLoaderStatus(false)
          //     })
          //     .catch(err => {
          //       this.setAppLoaderStatus(false)
          //     })
          // }
        })
        .catch(err => {
          //new logout api comes here
          this.$store.dispatch("Auth/logout")
          if (this.$route.name === "UserSymptoms" || this.$route.name === "UserTreatments") {
          } else {
            // UserRepository.recordLogout()
            // this.$store.dispatch("Auth/logout").then(() => {})
            // eventBus.$emit("refresh-circle-members-rootlogin");
          }
        })
      // }
    },

    handleProfileMultiRole() {
      // console.log("Current circle in handleprofilemultiple role is ", this.currentCircle);
      if (this.currentCircle && this.currentCircle.id) {
        AppRepository.getHasMultiRole(this.currentCircle.id)
          .then(res => {
            if (!res.data.data.length || res.data.data.length === 1) {
              this.isMultirole = false
            } else {
              this.isMultirole = true
            }
          })
          .catch(err => {})
      }
    },

    hideL() {
      if (this.$el.querySelector(".l-sidebar").classList.contains("l-sidebar-show")) {
        this.$el.querySelector(".l-sidebar").classList.remove("l-sidebar-show")
        document.querySelector(".backdrop").classList.remove("backdrop-show")
        // this.$el.querySelector(".backdrop").style.zIndex = -99;
      }
      this.$el.querySelector(".l-sidebar").classList.add("l-sidebar-hide")
      document.querySelector(".backdrop").classList.remove("backdrop-show")
      this.removeSidebar()
      this.$store.commit("Circle/setMobileSideMenuClicked", { data: false })
    },

    hideR() {
      if (this.$el.querySelector(".r-sidebar").classList.contains("r-sidebar-show")) {
        this.$el.querySelector(".r-sidebar").classList.remove("r-sidebar-show")
        document.querySelector(".right-side-backdrop").classList.remove("r-backdrop-show")
      }
      this.$el.querySelector(".r-sidebar").classList.add("r-sidebar-hide")
      document.querySelector(".right-side-backdrop").classList.remove("r-backdrop-show")
      this.removeSidebar()
    },

    removeSidebar() {
      if (document.querySelector("#app").classList.contains("no-scroll")) {
        document.querySelector("#app").classList.remove("no-scroll")
      }
      setTimeout(() => {
        if (this.$el.querySelector(".r-sidebar").classList.contains("r-sidebar-hide")) {
          this.$el.querySelector(".r-sidebar").classList.remove("r-sidebar-hide")
        }
        if (this.$el.querySelector(".l-sidebar").classList.contains("l-sidebar-hide")) {
          this.$el.querySelector(".l-sidebar").classList.remove("l-sidebar-hide")
        }
      }, 2000)
    },
    showProfile() {
      const profileType = this.authUser.user.role
      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" })
          break
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" })
          break
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" })
          break
        case "hospital_administrator":
          this.$router.push({ name: "HosUpdates" })
          break
        case "clinic_administrator":
          this.$router.push({ name: "ClinicUpdates" })
          break
        case "doctor":
          this.$router.push({ name: "DocUpdates" })
          break
        case "hcp":
          this.$router.push({ name: "HcpAbout" })
          break
        case "nfp_administrator":
          this.$router.push({ name: "NFPAbout" })
          break
        case "clinic_profile":
          this.$router.push({ name: "Clinic_Profile" })
          break
        default:
          this.$router.push({ path: `profile/${profileType}/updates` })
          break
      }
      this.hideR()
    },
    updateColor() {
      // console.log("(commented active) App - updateColor");
      // console.log(
      //   "$router.currentRoute.name ->",
      //   this.$router.currentRoute.name
      // );
      const excludeRoutes = ["AllCircles", "MyCircles", "ContactUs"]
      if (excludeRoutes.includes(this.$router.currentRoute.name)) {
        return
      }
      if (!this.$route.path.includes("home")) {
        return
      }
      // if (this.$el.querySelectorAll(".close")) {
      //   this.$el.querySelectorAll(".close").forEach((elem) => {
      //     elem.setAttribute(
      //       "style",
      //       `color: ${
      //         this.currentCircle ? this.currentCircle.color_code : "#000"
      //       } !important`
      //     );
      //   });
      // }
      if (this.$el.querySelectorAll("a")) {
        this.$el.querySelectorAll("a").forEach(elem => {
          if (elem.classList.contains("router-link-active")) {
            elem.setAttribute(
              "style",
              ` color: ${this.currentCircle ? this.currentCircle.color_code : "#000"} !important; ;
            background-color: ${this.getPrimary50Color()}`
            )
          } else {
            if (elem.hasAttribute("style")) {
              elem.removeAttribute("style")
            }
          }
        })
      }
    },
    goToSelectRolePage() {
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            this.$notification.error({ message: "Error", description: "You have only one role for this circle." })
          } else {
            this.$router
            this.$router.push(`/${this.currentCircle.key_name}/select-profile`).catch(err => {})
          }
        })
        .catch(err => {})
      this.hideR()
    },
    goToAllCirclesPage() {
      // console.log("goToAllCirclesPage is called");
      this.$router
        .push({
          // name: "AllCircles"
          path: "/searchpage",
        })
        .catch(err => {})
      this.hideR()
    },
  },
}
</script>

<style lang="scss">
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}
.loader-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  .loader-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 64px;
      height: 64px;
      margin: 8px;
      border: 8px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
@media screen and (max-width: 581px) {
  .side-bar {
    font-size: 14px;
    margin-top: 120px;
    z-index: 1 !important;
    padding-bottom: 130px;
  }
  // .switch-roles {
  //   margin-right: 10px;
  // }
}
// .svg-inline--fa {
//   vertical-align: middle;
// }
.l-sidebar {
  a {
    border-radius: 4px;
    padding: 8px !important;
    display: flex;
    // max-width: 300px;
    max-width: calc(100vw - 48px);
    align-items: center;
  }
}
.viewCircleBG {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.log-out-btn {
  @media screen and (max-width: 600px) {
    margin: 24px;
    width: 100% !important;
    max-width: calc(100vw - 48px);
    border: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue